import ProviderRedirect from "./ProviderRedirect";

export default ProviderRedirect;
